import { render, staticRenderFns } from "./CourseVideoPlaceholderBoard.vue?vue&type=template&id=1031ea86&scoped=true"
var script = {}
import style0 from "./CourseVideoPlaceholderBoard.vue?vue&type=style&index=0&id=1031ea86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031ea86",
  null
  
)

export default component.exports